module.exports = __webpack_public_path__ + "img/AK0094-GR.3994edd8.jpg";